import Backbone from 'backbone';

export default Backbone.Model.extend({
	defaults: {
		FirstItems: [],
		LastItems: [],
		ShowSearchBox: false
	}
});
